import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { globalScope } from '../constants/runtime';
import { now } from '../timing/now';
export var defaults = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net'
};
export function gosNREUM() {
  if (!globalScope.NREUM) {
    globalScope.NREUM = {};
  }

  if (typeof globalScope.newrelic === 'undefined') globalScope.newrelic = globalScope.NREUM;
  return globalScope.NREUM;
}
export function gosNREUMInfo() {
  var nr = gosNREUM();
  var externallySupplied = nr.info || {};
  nr.info = _objectSpread({
    beacon: defaults.beacon,
    errorBeacon: defaults.errorBeacon
  }, externallySupplied);
  return nr;
}
export function gosNREUMLoaderConfig() {
  var nr = gosNREUM();
  var externallySupplied = nr.loader_config || {};
  nr.loader_config = _objectSpread({}, externallySupplied);
  return nr;
}
export function gosNREUMInit() {
  var nr = gosNREUM();
  var externallySupplied = nr.init || {};
  nr.init = _objectSpread({}, externallySupplied);
  return nr;
}
export function gosNREUMOriginals() {
  var nr = gosNREUM();

  if (!nr.o) {
    nr.o = {
      ST: globalScope.setTimeout,
      SI: globalScope.setImmediate,
      CT: globalScope.clearTimeout,
      XHR: globalScope.XMLHttpRequest,
      REQ: globalScope.Request,
      EV: globalScope.Event,
      PR: globalScope.Promise,
      MO: globalScope.MutationObserver,
      // this'll be undefined if not in a web window
      FETCH: globalScope.fetch,
      WS: globalScope.WebSocket
    };
  }

  return nr;
}
export function setNREUMInitializedAgent(id, newAgentInstance) {
  var _nr$initializedAgents;

  var nr = gosNREUM();
  (_nr$initializedAgents = nr.initializedAgents) !== null && _nr$initializedAgents !== void 0 ? _nr$initializedAgents : nr.initializedAgents = {};
  newAgentInstance.initializedAt = {
    ms: now(),
    date: new Date()
  };
  nr.initializedAgents[id] = newAgentInstance;
}
/**
 * Get the agent instance under the associated identifier on the global newrelic object.
 * @see setNREUMInitializedAgents
 * @returns Existing agent instance under newrelic.initializedAgent[id], or undefined if it does not exist.
 */

export function getNREUMInitializedAgent(id) {
  var _nr$initializedAgents2;

  var nr = gosNREUM();
  return (_nr$initializedAgents2 = nr.initializedAgents) === null || _nr$initializedAgents2 === void 0 ? void 0 : _nr$initializedAgents2[id];
}
export function addToNREUM(fnName, fn) {
  var nr = gosNREUM();
  nr[fnName] = fn;
}
export function NREUMinitialized() {
  var nr = gosNREUM();
  nr.initialized = true;
}
export function gosCDN() {
  gosNREUMInfo();
  gosNREUMInit();
  gosNREUMOriginals();
  gosNREUMLoaderConfig();
  return gosNREUM();
}